import { createRequestType } from '../../helpers/requestType';

export const REPAINT_WORKFLOW_BUILDER = 'REPAINT_WORKFLOW_BUILDER';

export const initAppActionType = createRequestType('INIT_APP');
interface initAppRequestAction {
  type: typeof initAppActionType.request;
  payload: any;
}

interface initAppSuccessAction {
  type: typeof initAppActionType.success;
  payload: any;
}

interface initAppFailureAction {
  type: typeof initAppActionType.failure;
  payload: any;
}

export const updateBearerActionType = 'UPDATE_BEARER';
interface buildBotAction {
  type: typeof updateBearerActionType;
  payload: any;
}

export type AppActionTypes = initAppRequestAction | initAppSuccessAction| initAppFailureAction | buildBotAction
